import "core-js/stable";
import CoreuiVue from "@coreui/vue/src";

const init = (instace) => {
  instace.use(CoreuiVue);
};

export default init;
